(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector-react/assets/react/account-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector-react/assets/react/account-selector.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback,
  useReducer = _React.useReducer;
const accountSelector = svs.numbergames.accountSelector;
const _svs$numbergames$acco = svs.numbergames.accountSelector.constants.events,
  FETCHED = _svs$numbergames$acco.FETCHED,
  ACTIVE_ACCOUNT_CHANGED = _svs$numbergames$acco.ACTIVE_ACCOUNT_CHANGED,
  ACCOUNT_BALANCE_UPDATED = _svs$numbergames$acco.ACCOUNT_BALANCE_UPDATED;
const _svs$numbergames$acco2 = svs.numbergames.accountSelectorReact,
  reducer = _svs$numbergames$acco2.reducer,
  initialState = _svs$numbergames$acco2.initialState,
  _svs$numbergames$acco3 = _svs$numbergames$acco2.actions,
  setAccountList = _svs$numbergames$acco3.setAccountList,
  fetchAccountList = _svs$numbergames$acco3.fetchAccountList,
  setAccount = _svs$numbergames$acco3.setAccount,
  initialize = _svs$numbergames$acco3.initialize;
const _svs$ui$reactForm = svs.ui.reactForm,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const formatCurrency = svs.utils.format.Currency;
const AccountSelector = _ref => {
  let onChange = _ref.onChange;
  const _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(() => {
    const listener = async () => typeof onChange === 'function' && onChange(await accountSelector.getActiveAccount());
    const events = {
      [ACTIVE_ACCOUNT_CHANGED]: listener
    };
    accountSelector.on(events);
    return () => accountSelector.off(events);
  }, [onChange]);
  useEffect(() => {
    const fetchedListener = _ref2 => {
      let accounts = _ref2.accounts,
        selectedAccount = _ref2.selectedAccount,
        selectedAccountChanged = _ref2.selectedAccountChanged;
      return dispatch(initialize(accounts, selectedAccount, selectedAccountChanged));
    };
    const balanceUpdatedListener = _ref3 => {
      let accounts = _ref3.accounts;
      return dispatch(setAccountList(accounts));
    };
    const events = {
      [FETCHED]: fetchedListener,
      [ACCOUNT_BALANCE_UPDATED]: balanceUpdatedListener
    };
    accountSelector.on(events);
    dispatch(fetchAccountList());
    return () => accountSelector.off(events);
  }, []);
  const handleAccountChange = useCallback(async _ref4 => {
    let value = _ref4.target.value;
    dispatch(setAccount(value));
    typeof onChange === 'function' && onChange(await accountSelector.getActiveAccount());
  }, [onChange, dispatch]);
  if (!state.accountList || state.accountList.length === 1) {
    return React.createElement("div", {
      className: "u-invisible"
    }, React.createElement(Select, {
      v2: true
    }));
  }
  return React.createElement(Select, {
    onChange: handleAccountChange,
    v2: true,
    value: state.selectedAccount
  }, state.accountList.map(_ref5 => {
    let id = _ref5.id,
      name = _ref5.name,
      balance = _ref5.balance;
    return React.createElement(Option, {
      value: id,
      key: id
    }, "".concat(name, " (").concat(formatCurrency(balance), " kr)"));
  }));
};
svs.numbergames.accountSelectorReact.AccountSelector = AccountSelector;

 })(window);